<nav class="navbar fixed-top p-0 NavbarBg" role="navigation" [style.min-height]="NavHeight">
    <div class="container-fluid">
        <div class="navbar-header">
            <a class="navbar-brand LogoAnchorClass logo1">
                <img class="logo_img" [src]='logo' [style.height]="logoHeight">
            </a>

        </div>
        <div class="SBName">
          <b>{{SubBrokerName}}</b>
        </div>
    </div>
</nav>
